import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as websocket from "../../utils/communication.js";
import * as language from "../../utils/language.js";
import AnalogOutElement from "./AnalogOutElement.jsx";

const AnalogOut = observer((props) => {
  //========================================================================
  // Datenpunkte anmelden
  useEffect(() => {
    let newReqDataValues = globalVars.reqDataValues;

    for (let i = 0; i < props.props.ioVariables.length; i++) {
      for (let j = 0; j < props.props.ioVariables[i].number; j++) {
        let varStringManAuto =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".bManAuto";
        let varStringManValue =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fManValue";
        let varStringAo =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fAo";
        let varStringHardw =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".nHardw";

        if (!newReqDataValues.includes(varStringManAuto)) {
          newReqDataValues.push(varStringManAuto);
        }
        if (!newReqDataValues.includes(varStringManValue)) {
          newReqDataValues.push(varStringManValue);
        }
        if (!newReqDataValues.includes(varStringAo)) {
          newReqDataValues.push(varStringAo);
        }
        if (!newReqDataValues.includes(varStringHardw)) {
          newReqDataValues.push(varStringHardw);
        }
      }
    }

    if (newReqDataValues.length > 0) {
      globalVars.setReqDataValues(newReqDataValues);
      websocket.registerDataPoints(
        globalVars.ws,
        globalVars.reqDataValues,
        "register",
      );
    }
  }, []);

  //========================================================================
  // Variablennamen zusammensetzen
  let dat = [];

  for (let i = 0; i < props.props.ioVariables.length; i++) {
    for (let j = 0; j < props.props.ioVariables[i].number; j++) {
      dat.push({
        manAuto:
          props.props.ioVariables[i].variable + ".Kanal" + j + ".bManAuto",
        manValue:
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fManValue",
        anaOut: props.props.ioVariables[i].variable + ".Kanal" + j + ".fAo",
        hardw: props.props.ioVariables[i].variable + ".Kanal" + j + ".nHardw",
      });
    }
  }

  let names = props.element.ioNames;

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        overflowY: "auto",
        backgroundColor: "#53535399",
        display: "grid",
        gap: "1.2%",
        alignItems: "baseline",
        alignContent: "baseline",
      }}
    >
      <div
        style={{
          position: "sticky",
          top: 0,
          left: `calc(${globalVars.scaleFactor} * 10px)`,
          width: `calc(100% - (${globalVars.scaleFactor} * 30px))`,
          height: `calc(${globalVars.scaleFactor} * 40px)`,
          backgroundColor: "#3f3f3f",
          color: "white",
          fontWeight: "bold",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "0",
          paddingLeft: `calc(${globalVars.scaleFactor} * 10px)`,
          zIndex: 2,
        }}
      >
        <div
          style={{
            position: "absolute",
            left: `calc(${globalVars.scaleFactor} * 10px)`,
            width: `calc(${globalVars.scaleFactor} * 200px)`,
            textAlign: "left",
          }}
        >
          {language.displayText(["Bezeichnung", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 350px)`,
            width: `calc(${globalVars.scaleFactor} * 80px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Hand/Auto", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 245px)`,
            width: `calc(${globalVars.scaleFactor} * 80px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Analog Out", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 130px)`,
            width: `calc(${globalVars.scaleFactor} * 80px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Man. Wert", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 15px)`,
            width: `calc(${globalVars.scaleFactor} * 80px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Hardware", "", ""])}
        </div>
      </div>

      {Array.isArray(dat) &&
        dat.map((item, index) => (
          <AnalogOutElement
            data={item}
            name={names?.[index] ?? "error"}
            style={props.style}
            authWrite={props.authWrite}
          />
        ))}
    </div>
  );
});

export default AnalogOut;
